
const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/c440d1425e5c2401af40231c40440ccd.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-2xl">
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Durban's Most Trusted Bakkie Removals &amp; Landscaping Services
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 font-light">
            Fast • Affordable • Insured Transport Across KwaZulu-Natal
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-primary-dark transition-all hover:scale-105 inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
              Get Instant Quote
            </a>
            <a
              href="tel:+27798768956"
              className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-primary transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
              Call 079 876 8956
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
